export default __webpack_public_path__ + "static/media/postgress.c56c146c.png";